import React, { useState, useRef, useEffect } from "react";
import "./narrowDropdown2.css";
import UpIcon from "./assets/upIcon.png";
import DownIcon from "./assets/downIcon.png";
import CheckedIcon from "./assets/checkedIcon.png";
import UncheckedIcon from "./assets/uncheckedIcon.png";

const NarrowDropdown2 = ({
  title,
  placeholder,
  subLabel,
  items,
  isRequired,
  value,
  onChange,
  multiple = false,
  halfWidth = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleItemClick = (item) => {
    if (multiple) {
      // For multi-select, add or remove the item's value from the array
      if (Array.isArray(value) && value.includes(item.value)) {
        onChange(value.filter((v) => v !== item.value));
      } else {
        onChange([...(Array.isArray(value) ? value : []), item.value]);
      }
    } else {
      onChange(item.value);
      setIsOpen(false);
    }
  };

  const renderValue = () => {
    // if (multiple) {
    //   if (Array.isArray(value) && value.length > 0) {
    //     // Map selected values to their corresponding labels
    //     const labels = items
    //       .filter((item) => value.includes(item.value))
    //       .map((item) => item.label);
    //     return labels.join(", ");
    //   }
    //   return placeholder;
    if (multiple) {
      if (Array.isArray(value) && value.length > 0) {
        // Find all selected labels
        const selected = items.filter((item) => value.includes(item.value));
        const labels = selected.map((item) => item.label);
        if (labels.length === 1) {
          return labels[0];
        }
        // More than one: show first label + “+count”
        return `${labels[0]} +${labels.length - 1}`;
      }
      return placeholder;
    } else {
      const selectedItem = items.find((item) => item.value === value);
      return selectedItem ? selectedItem.label : placeholder;
    }
  };

  const displayValue = renderValue();
  const isPlaceholder = displayValue === placeholder;

  return (
    <div
      className={`dropdown-field ${halfWidth ? "half-width" : "narrow"}`}
      ref={containerRef}
    >
      <label className="dropdown-label">
        {title} {isRequired && <span className="required"> *</span>}
      </label>
      {subLabel && <div className="dropdown-sublabel">{subLabel}</div>}
      <div className="dropdown-display" onClick={toggleDropdown}>
        <span
          className={
            isPlaceholder ? "dropdown-placeholder" : "dropdown-selected"
          }
        >
          {displayValue}
        </span>
        <span className="dropdown-arrow">
          <img
            src={isOpen ? UpIcon : DownIcon}
            alt={isOpen ? "Up arrow" : "Down arrow"}
            style={{ width: "24px", height: "24px" }}
          />
        </span>{" "}
      </div>
      {isOpen && (
        <div className="dropdown-menu">
          {items.map((item, index) => (
            <div
              key={index}
              className="dropdown-item"
              onClick={() => handleItemClick(item)}
            >
              {multiple && (
                <img
                  src={
                    Array.isArray(value) && value.includes(item.value)
                      ? CheckedIcon
                      : UncheckedIcon
                  }
                  alt={
                    Array.isArray(value) && value.includes(item.value)
                      ? "Checked"
                      : "Unchecked"
                  }
                  className="dropdown-checkbox-icon"
                />
              )}
              <span className="dropdown-item-text">{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NarrowDropdown2;
